<template>
    <custom-dialog width="1106px" :showClose="true" title="执行看板" v-if="visibleObj.executeBoardDialog"
        :visible="visibleObj.executeBoardDialog" @close="dialogVisible('executeBoardDialog')">
        <div slot="content">
            <div class="content-top">
                <el-radio-group v-model="dateType" @input="changeDateType">
                    <el-radio-button :label="1">今天</el-radio-button>
                    <el-radio-button :label="2">昨天</el-radio-button>
                    <el-radio-button :label="3">本周</el-radio-button>
                    <el-radio-button :label="4">本月</el-radio-button>
                    <el-radio-button :label="5">上月</el-radio-button>
                </el-radio-group>
                <div class="ml16">
                    <el-date-picker @focus="dateFocus" @change="getExecutePhysioPage" v-model="dateRange" type="daterange"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </div>

            </div>
            <div class="mt20">
                <customTable height="440" @pageChange="pageChange" class="customTable" :tableData="tableData"
                    :column="column" :total="total" :currentPage="searchFrom.pageNum"
                    :header-cell-style="{ background: '#F0F1F3' }">
                </customTable>
            </div>
        </div>
        <div slot="footer"></div>
    </custom-dialog>
</template>
  
<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import customTable from '@/components/customTable/customTable'
import { Utils } from '@/utils/utils'
import { drugDTO, CommonDTO } from '@/DTO/index'
export default {
    // 定义引入的组件
    components: { CustomDialog, customTable },
    props: {
        visibleObj: {
            type: Object,
            default: () => { return {} }
        },
        dialogObj: {
            type: Object,
            default: () => { return {} }
        },
    },
    data() {
        return {
            systemTime: '',//系统时间
            dateType: 1,
            dateRange: [],
            tableData: [],//表格数据
            column: [
                { type: 'index', label: '序号' },
                { label: '患者', prop: 'patientName' },
                { label: '性别', prop: 'sex', formatter: (row) => { return row.sex == '0' ? '男' : '女' } },
                { label: '手机号', prop: 'phone' },
                { label: '诊断', prop: 'diagnosis' },
                { label: '执行项目', prop: 'physioName' },
                { label: '单价', prop: 'price' },
                { label: '执行次数', prop: 'executeNum' },
                { label: '小计', prop: 'costMoney' },
                { label: '执行时间', prop: 'executeDate' },
                { label: '治疗时长', prop: 'executeTimeLength' },
            ],
            total: 0,//总数
            searchFrom: {
                deptId: this.$session.get('deptId'),
                pageSize: 10,
                currentPage: 1,
            },
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    async created() {
        this.systemTime = CommonDTO.getSystemTimeDTO()
        await this.getExecutePhysioPage()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {

        /**
         * 日期选择器聚焦
         */
        dateFocus() {
            this.dateType = 6
        },

        /**
         * 分页获取数据
         */
        async getExecutePhysioPage() {
            this.computeDate();
            let { code, rows, total } = await drugDTO.executePhysioPage(this.searchFrom)
            if (code == 200) {
                this.tableData = rows
                this.total = total
            }
        },

        /**
      * 关闭
      */
        dialogVisible(name) {
            this.$emit("close", name);
        },
        /**
         * 页码改变
         */
        pageChange(obj) {
            let { current, size } = obj
            this.searchFrom.currentPage = current
            this.searchFrom.pageSize = size
            this.getExecutePhysioPage()
        },
        /**
         * 计算选择时间的时间戳
         */
        computeDate() {
            let lastMon = this.$moment(this.systemTime).subtract(1, 'months')
            let nowDay = this.$moment(this.systemTime)
            let yesterday = this.$moment(this.systemTime).subtract(1, 'days')
            switch (this.dateType) {
                case 1: //今天
                    this.searchFrom.startDate = Utils.startOfDay(nowDay)
                    this.searchFrom.endDate = Utils.endOfDay(nowDay)
                    break;
                case 2: //昨天
                    this.searchFrom.startDate = Utils.startOfDay(yesterday)
                    this.searchFrom.endDate = Utils.endOfDay(yesterday)
                    break;
                case 3: //本周
                    this.searchFrom.startDate = Utils.startOfDay(this.$moment(nowDay).startOf('isoWeek'))
                    this.searchFrom.endDate = Utils.endOfDay(this.$moment(nowDay).endOf('isoWeek'))
                    break;
                case 4: //本月
                    this.searchFrom.startDate = Utils.startOfDay(this.$moment(nowDay).startOf('month'))
                    this.searchFrom.endDate = Utils.endOfDay(this.$moment(nowDay).endOf('month'))
                    break;
                case 5: //上月
                    this.searchFrom.startDate = Utils.startOfDay(this.$moment(lastMon).startOf('month'))
                    this.searchFrom.endDate = Utils.endOfDay(this.$moment(lastMon).endOf('month'))
                    break;
                case 6: //自定义
                    this.searchFrom.startDate = Utils.startOfDay(this.dateRange[0])
                    this.searchFrom.endDate = Utils.endOfDay(this.dateRange[1])
                    break;
            }
        },
        /**
         * 切换时间
         */
        changeDateType(val) {
            this.dateRange = []
            if (val == 6) return
            this.searchFrom.currentPage = 1
            this.getExecutePhysioPage()
        }
    },
}
</script>
<style lang="less" scoped>
.content-top {
    display: flex;
    align-items: center;
}
</style>